import router from "./router"
import store from './store'
import { getToken, cookiesList, setCookie } from './utils/cookies'
import { changeType } from './api/public'
import { autoLogin } from '@/utils/freeLogin'

const whiteRoutes = ['/', '/login', '/forget-password', '/dealer/index', '/dealer/goods/list', '/dealer/goods/detail']
router.beforeEach((to,from, next) => {
    // console.log(to, from)
    if (getToken()) {
        if (!store.state.user.token) {
            store.dispatch('getLocalInfo')
        }
        if (to.path == '/login') {
            if (store.state.user.userType == 'dealer') {
                next('/dealer')
            } else if (store.state.user.userType == 'supplier') {
                next('/supplier')
            } else {
                next()
            }
        } else if (to.matched[0].path != '/' + store.getters.userType) {
            next('/' + store.getters.userType)
        } else {
            next()
            // changeTypeToServer(to, from)
            // setUserTypeCookie(to)
        }
    } else if (to.query.yjj_phone && to.query.yjj_code) {
        // next()
        autoLogin(to.query.yjj_phone, to.query.yjj_code)
    } else {
        if (whiteRoutes.indexOf(to.path) !== -1) {
            next()
        } else {
            store.dispatch('clearLocalData');
            next('/login')
        }
    } 
})

/* 将当前用户状态存入cookie */
function setUserTypeCookie (to) {
    ['supplier', 'dealer'].forEach(item => {
        if (to.matched[0].path == '/' + item && to.matched[0].path != '/' + store.getters.userType) {
            store.commit('setUserType', item)
            setCookie(cookiesList.user_type, item)
        }
    })
}

/* 切换身份时后当前用户身份传给后端 */
function changeTypeToServer(to, from) {
    let toType = to.fullPath.split('/')[1]
    let fromType = from.fullPath.split('/')[1]
    let userInitialType
    let typeArr = ['supplier', 'dealer']
    if (toType == typeArr[0] &&　fromType == typeArr[1]) userInitialType = 1
    if (toType == typeArr[1] &&　fromType == typeArr[0]) userInitialType = 2
    if (userInitialType) {
        changeType({
            "userId": store.getters.userId,
            "userInitialType": userInitialType
        }).then(res => {
            console.log(res)
        }).catch(err => {
            console.log(err)
        })
    }
    
}